import { applyCampaignSiteSlugNames } from "@/utils/campaignSiteSlug";
import { channelPlacements, dailySites, placementCreatives } from "@/trpc/calls";
import { trpc } from "@/trpc/client";
import { siteIdFrom } from "@/trpc/listFilter";

const getStatusSite = async (variables) => {
  const siteId = siteIdFrom(variables);
  if (!siteId) return null;
  const result = await trpc.lookups.sites.list.query({
    limit: 1,
    offset: 0,
    site_ids: [siteId],
  }).catch(() => ({ rows: [] }));
  return result.rows?.[0] ?? null;
};

const getTablePerDaySites = async (variables) => {
  const sites = await dailySites(variables);
  return applyCampaignSiteSlugNames(sites, variables);
};

const getTablePerDayChannels = async (variables) => {
  const sites = await dailySites(variables);
  return applyCampaignSiteSlugNames(sites, variables);
};

const getTablePerDayPlacements = async (variables) => channelPlacements(variables);

const getTablePerDayCreatives = async (variables) => placementCreatives(variables);

export {
  getStatusSite,
  getTablePerDaySites,
  getTablePerDayChannels,
  getTablePerDayPlacements,
  getTablePerDayCreatives,
};

